// src/pages/buy&rent.js
import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { businessSchemaDE, businessSchemaEN } from "../schema";
import BuyRent from "../components/buy&rent/buy&rent";

// Import page-level translations
import buyrentEnTranslations from "../translations/buyrent_en.json";
import buyrentDeTranslations from "../translations/buyrent_de.json";

const BuyRentPage = () => {
  const { t, i18n } = useTranslation();

  // Add translations for this page
  i18n.addResourceBundle(
    "en",
    "buyrentPage",
    buyrentEnTranslations,
    true,
    true
  );
  i18n.addResourceBundle(
    "de",
    "buyrentPage",
    buyrentDeTranslations,
    true,
    true
  );

  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(currentSchema)}
        </script>
        <title>{t("buyrentPage:page_title")}</title>
        <meta name="description" content={t("buyrentPage:meta_description")} />
        <meta name="keywords" content={t("buyrentPage:meta_keywords")} />
        <meta property="og:title" content={t("buyrentPage:page_title")} />
        <meta
          property="og:description"
          content={t("buyrentPage:meta_description")}
        />
      </Helmet>
      <div>
        <BuyRent />
      </div>
    </>
  );
};

export default BuyRentPage;
